import React, { ReactElement, useContext, useEffect, useState } from 'react'
import axios from 'axios'
import { ArtData } from '@/database/art'
import { Context } from '@/components/Context'
import CheckBox from '@/components/boxes/CheckBox'
import serverConfig from '@/server-config'
import MintCard from '@/components/mint/MintCard'

axios.defaults.baseURL = serverConfig.baseURL

const ListingOverview = ({
    openModalMintCardDetails,
}: {
    openModalMintCardDetails: (artData: ArtData) => void
}): ReactElement => {
    const { proposalData, currentAccount } = useContext(Context)
    const [showLatest, setShowLatest] = useState(false)
    const [showVoted, setShowVoted] = useState(false)
    const [recentData, setRecentData] = useState<ArtData[]>([])
    const isColumn = window.innerWidth < 450

    useEffect(() => {
        const latestData = [...proposalData]
            .sort((a, b) => {
                // Convert to Date objects if not already, and handle potential null/undefined
                const dateA = new Date(a.art.createdAt ?? 0) // Fallback to epoch if undefined/null
                const dateB = new Date(b.art.createdAt ?? 0) // Fallback to epoch if undefined/null

                // Compare the timestamps
                return dateB.getTime() - dateA.getTime()
            })
            .slice(0, 20)
        setRecentData(latestData)
    }, [proposalData])

    const filteredArt = (artDataList: ArtData[]) =>
        artDataList.filter((artData) => {
            if (
                showVoted &&
                artData.votes.some((voteData) => voteData.vote.voteUser.walletAddress === currentAccount)
            ) {
                return true
            }
            if (showLatest && recentData.some((propsData) => artData.art.id === propsData.art.id)) {
                return true
            }
            if (!showVoted && !showLatest) {
                return true
            }
            if (showVoted) {
                return false
            }
        })

    return (
        <div>
            <p className="nav__brand">
                <CheckBox
                    btnName="Voted"
                    classStyles=""
                    checked={showVoted}
                    handleClick={() => setShowVoted(!showVoted)}
                />
                <CheckBox
                    btnName="Latest"
                    classStyles=""
                    checked={showLatest}
                    handleClick={() => setShowLatest(!showLatest)}
                />
            </p>
            <div className="container">
                <div>
                    <div className="prompts">
                        <ul>
                            {filteredArt(showLatest ? recentData : proposalData).map((art, index) => (
                                <div
                                    key={art.art.id}
                                    className={isColumn ? 'menu-wrapper-column' : 'menu-wrapper-row' + ' left-row'}
                                >
                                    <h2>#{index + 1}</h2>
                                    <MintCard artData={art} openModalMintCardDetails={openModalMintCardDetails} />
                                </div>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ListingOverview
